/**
 * This helper allows "connect"-like semantics within an action.  Define an action creator as
 * normal, but instead of getState, the second argument after "dispatch" will be a mapped state
 * object produced by the "mapStateToArgs" function.  Define that function and export it wrapped
 * with withMappedState to automatically produce the state values you need in the action, derived
 * from the full tree, using a familiar pattern.
 * @param actionCreator An action creator function.
 * @param mapStateToArgs A mapping function.  Defaults to returning the entire tree.
 * @returns {function(...[*]): function(*=, *): *}
 */
const withMappedState = (actionCreator, mapStateToArgs = (_ => _)) =>
  (...args) => (dispatch, getState) => {
    const mappedState = mapStateToArgs(getState());
    return actionCreator(...args, mappedState)(dispatch);
  };

export default withMappedState;



// WEBPACK FOOTER //
// ./src-react/Utils/withMappedState.jsx